import * as React from "react";
import { Tooltip, OverlayTrigger, Glyphicon } from "react-bootstrap";

export default class TextoAyuda extends React.Component<TextoAyudaProps> {

    render() {
        const { texto } = this.props;

        const textoAyuda = (
            <Tooltip id="tooltip">
                <span className="tooltip-font">{texto}</span>
            </Tooltip>
        );

        return (
            <OverlayTrigger placement="top" overlay={textoAyuda}>
                <Glyphicon className={"info-sign icon-label"} glyph={"info-sign"} />
            </OverlayTrigger>
        );
    }
}

interface TextoAyudaProps {
    texto: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/TextoAyuda.tsx